import useLadyService from '@/services/LadyService';
import { hideShort } from '@/stores/slices/showFilterSlice';
import { useMemo, useCallback } from 'react';
import FilterData from '../filter/FilterData';
import { useSelector } from 'react-redux';
import {
	getAgencyDisabledFilters,
	getDisabledFilters,
	getFilterQuery,
} from '@/stores/slices/filterSlice';

const ShortFilterData = () => {
	const { t, isAgencyPage, lang, dispatch } = useLadyService();

	const filterData = FilterData({ useAgencyDisabled: isAgencyPage });

	const disabled_filters = useSelector(
		isAgencyPage ? getAgencyDisabledFilters : getDisabledFilters,
	);
	const disabledSet = useMemo(
		() => new Set(disabled_filters),
		[disabled_filters],
	);

	const query = useSelector(getFilterQuery);
	const querySet = useMemo(
		() =>
			new Set(
				query.map((i) => {
					return i.replace('=1', '');
				}),
			),
		[query],
	);

	const parseQuery = useCallback((qa, key) => {
		const item = qa.find((item) => item.startsWith(`${key}=`));
		return item ? item.split(`${key}=`)[1].split(',') : [];
	}, []);

	const hairQuerySet = useMemo(() => {
		return new Set(parseQuery(query, 'hair'));
	}, [query]);

	const servicesQuerySet = useMemo(() => {
		return new Set(parseQuery(query, 'services'));
	}, [query]);

	const ethnosQuerySet = useMemo(() => {
		return new Set(parseQuery(query, 'ethnos'));
	}, [query]);

	const shortFilterOptions = new Set([
		'elitelady',
		'indi',
		'pornstar',
		'booking',
		'ero',
		'vchat',
		'verified',
		'new',
		'online',
		'blondes',
		'asian',
		'bdsm',
		'anal',
		'healthy',
	]);

	const dynamic_part = useMemo(
		() => filterData.status.filter((i) => shortFilterOptions.has(i.value)),
		[filterData],
	);

	const orderMap = useMemo(() => {
		const order = Array.from(shortFilterOptions);
		return new Map(order.map((value, index) => [value, index]));
	}, []);

	const options = useMemo(() => {
		const blondes = {
			id: 'hairBlond',
			title: t('blondes'),
			name: 'hair',
			value: 'blond',
			path: 'blondes',
			checked: hairQuerySet.has('blond'),
			disabled: disabledSet.has('statusBlond'),
			translateKey: 'blondes',
		};

		const asian = {
			id: 201,
			title: t('asiatag'),
			name: 'ethnos',
			path: 'asian',
			value: 'asian',
			checked: ethnosQuerySet.has('asian'),
			disabled: disabledSet.has('statusAsian'),
			translateKey: 'asiatag',
		};

		const anal = {
			id: 200,
			title: t('anal-sex'),
			name: 'services',
			value: '2',
			path: 'anal',
			checked: servicesQuerySet.has('2'),
			disabled: disabledSet.has('statusAnal'),
			translateKey: 'anal-sex',
		};

		const links = [
			{
				id: 140,
				title: t('agency'),
				name: 'agency',
				value: 'agency',
				onClick: () => {
					dispatch(hideShort());
				},
				isLink: `/${lang}/agencies`,
			},
			{
				id: 141,
				title: t('massagestudios'),
				name: 'massagebrothel',
				value: 'massagebrothel',
				onClick: () => {
					dispatch(hideShort());
				},
				isLink: `/${lang}/massagebrothels`,
			},
		];

		const arr = [...dynamic_part, asian, blondes, anal, ...links];

		if (!isAgencyPage) {
			const hasIndi = dynamic_part.some((item) => item.value === 'indi');
			if (!hasIndi) {
				arr.splice(1, 0, {
					id: 11,
					title: t('indi'),
					name: 'status',
					value: 'indi',
					checked: querySet.has('indi'),
					disabled: disabledSet.has('statusIndividual'),
					translateKey: 'indi',
				});
			}
		}

		return arr.sort((a, b) => {
			const aOrder = orderMap.get(a.value) ?? orderMap.get(a.path) ?? 999;
			const bOrder = orderMap.get(b.value) ?? orderMap.get(b.path) ?? 999;
			return aOrder - bOrder;
		});
	}, [lang, isAgencyPage, dynamic_part, querySet, t]);

	return {
		main_title: t('more'),
		options,
	};
};
export default ShortFilterData;
